import React from 'react';
import { Link } from 'react-router-dom';
import pageHeaderBg from '../assets/images/page-header-bg.jpg';

function Terms() {
  return (
    <div className="terms-page">
      <section className="page-header parallaxie" style={{backgroundImage: `url(${pageHeaderBg})`}}>
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-12">
              <div className="page-header-box">
                <h1 className="text-anime-style-2" data-cursor="-opaque">Terms and Conditions</h1>
                <nav className="wow fadeInUp">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item"><Link to="/">home</Link></li>
                    <li className="breadcrumb-item active" aria-current="page">terms and conditions</li>
                  </ol>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="page-content">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="terms-content">
                <div className="section-title">
                  <div style={{marginBottom: '40px'}}></div>
                </div>

                <div className="terms-section">
                  <h3>Service Overview</h3>
                  <p>COVAI HELLO TRUCK PRIVATE LIMITED (operating as Hello Truck) is a technology-driven platform that connects customers with mini truck drivers and logistics partners for transportation services. We offer booking for a variety of light commercial vehicles including Tata Ace, Bolero Pickup, Tata 407, and Tata Intra.</p>
                </div>

                <div className="terms-section">
                  <h3>Eligibility</h3>
                  <p>To use our services, you must:</p>
                  <ul>
                    <li>Be at least 18 years old.</li>
                    <li>Provide valid contact and identity details.</li>
                    <li>Agree to comply with all applicable Indian laws and transport regulations.</li>
                  </ul>
                </div>

                <div className="terms-section">
                  <h3>User Responsibilities</h3>
                  <p>By using our platform, you agree to:</p>
                  <ul>
                    <li>Provide accurate booking information (pickup/drop location, goods type, weight, etc.).</li>
                    <li>Ensure proper packaging and labeling of goods.</li>
                    <li>Be present at the pickup location on time.</li>
                    <li>Cooperate with drivers and logistics partners.</li>
                    <li>Refrain from transporting prohibited or illegal items.</li>
                  </ul>
                </div>

                <div className="terms-section">
                  <h3>Booking, Cancellation & Rescheduling</h3>
                  <p>All bookings must be confirmed via the app, website, or phone.</p>
                  <ul>
                    <li>Bookings can be canceled or rescheduled up to 1 hour before pickup without charge.</li>
                    <li>Last-minute cancellations or no-shows may incur charges.</li>
                    <li>In rare cases (traffic, strikes, vehicle breakdowns), we reserve the right to reschedule or cancel the trip with prior notice.</li>
                  </ul>
                </div>

                <div className="terms-section">
                  <h3>Pricing and Payments</h3>
                  <p>Fare is calculated based on distance, vehicle type, time, and additional services.</p>
                  <ul>
                    <li>Final charges may include tolls, parking, waiting time, and loading/unloading assistance.</li>
                    <li>Accepted payment modes include UPI, credit/debit cards, net banking, and cash on delivery.</li>
                    <li>GST and applicable taxes are added to the invoice as per government norms.</li>
                  </ul>
                </div>

                <div className="terms-section">
                  <h3>Driver & Partner Responsibilities</h3>
                  <p>All Hello Truck partner drivers:</p>
                  <ul>
                    <li>Are background-verified and trained.</li>
                    <li>Must maintain vehicle hygiene and timely service.</li>
                    <li>Are expected to follow safe driving and customer etiquette.</li>
                  </ul>
                  <p>However, Hello Truck is not responsible for delays or disputes arising from individual driver behavior, though we take complaints seriously and investigate them promptly.</p>
                </div>

                <div className="terms-section">
                  <h3>Limitation of Liability</h3>
                  <p>Hello Truck acts as an aggregator and does not own or operate transport vehicles.</p>
                  <ul>
                    <li>We are not liable for delays, losses, or damages unless directly caused by our negligence.</li>
                    <li>We do not provide insurance coverage for your goods unless explicitly requested.</li>
                  </ul>
                </div>

                <div className="terms-section">
                  <h3>Account Suspension and Termination</h3>
                  <p>We reserve the right to suspend or terminate your account if:</p>
                  <ul>
                    <li>Fraudulent bookings are detected.</li>
                    <li>Repeated violations of terms occur.</li>
                    <li>Abusive, threatening, or illegal behavior is reported.</li>
                  </ul>
                  <p>We may take legal action where necessary.</p>
                </div>

                <div className="terms-section">
                  <h3>Privacy and Data Use</h3>
                  <p>Your personal data is collected and used in accordance with our Privacy Statement. We take reasonable security measures to protect your information.</p>
                </div>

                <div className="terms-section">
                  <h3>Changes to Terms</h3>
                  <p>COVAI HELLO TRUCK PRIVATE LIMITED may revise these Terms at any time without prior notice. Continued use of the service indicates your acceptance of the updated terms.</p>
                </div>

                <div className="terms-section">
                  <h3>Contact Us</h3>
                  <p>For any queries, complaints, or feedback:</p>
                  <ul>
                    <li>Email: <a href="mailto:support@hellotruck.in">support@hellotruck.in</a></li>
                    <li>Phone: <a href="tel:+917053315331">+91 70533 15331</a></li>
                    <li>Address: No.7, Gandhi Nagar 3rd Street, Varadharajapuram, Singanallur, Coimbatore – 641015</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Terms;
